import React from 'react';

import {Radio, RadioProps} from '@material-ui/core';

type Props = {
    selectedValue: string;
};

export default function EfeRadioButton(props: RadioProps & Props) {
    const {value, selectedValue, ...other} = props;

    return <Radio checked={value === selectedValue} {...other} />;
}
